// import { watch } from 'vue';
// на выходе данные массив обьектов содержашиеся в this.selectedUsers
{
}
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      // selectedUsers: [],
      // selectedUsers_elem: []
    };
  },
  computed: {
    isAllSelected() {
      // Проверяем, выбраны ли все пользователи
      return this.students_id.length === this.totalUsersCount();
    },
    ...mapState({
      students: state => state.modalUsers.users,
      students_id: state => state.modalUsers.users_id,
      users_ids_permit: state => state.modalUsers.users_ids_permit
    })
  },
  methods: {
    ...mapMutations({
      SET_USERS_ID: 'modalUsers/SET_USERS_ID',
      PYSH_USERS_ID: 'modalUsers/PYSH_USERS_ID',
      SET_USERS: 'modalUsers/SET_USERS',
      PYSH_USERS: 'modalUsers/PYSH_USERS',
      FILTER_AND_REMOVE_USERS: 'modalUsers/FILTER_AND_REMOVE_USERS',
      FILTER_AND_REMOVE_USERS_ID: 'modalUsers/FILTER_AND_REMOVE_USERS_ID'
    }),
    totalUsersCount() {
      // Вспомогательный метод для получения общего количества пользователей
      return this.users.reduce((total, group) => total + group.length, 0);
    },
    isSelected(userId) {
      // console.log(this.selectedUsers, 'isSelected');
      // Проверяем, выбран ли пользователь по его айдишнику
      return this.students_id.includes(Number(userId.user_id));
    },
    isUserPermit(user) {
      const chechk = this.users_ids_permit.includes(Number(user.user_id));
      if (
        (chechk &&
          user.exit_permission_user_statuses &&
          user.exit_permission_user_statuses.length > 0 &&
          user.exit_permission_user_statuses[0].status === 'active_use') ||
        (chechk &&
          user.exit_permission_user_statuses &&
          user.exit_permission_user_statuses.length > 0 &&
          user.exit_permission_user_statuses[0].status === 'expired_delay') ||
        (chechk &&
          user.exit_permission_user_statuses &&
          user.exit_permission_user_statuses.length > 0 &&
          user.exit_permission_user_statuses[0].status === 'completed_delay') ||
        (chechk &&
          user.exit_permission_user_statuses &&
          user.exit_permission_user_statuses.length > 0 &&
          user.exit_permission_user_statuses[0].status === 'completed') ||
        (chechk &&
          user.exit_permission_user_statuses &&
          user.exit_permission_user_statuses.length > 0 &&
          user.exit_permission_user_statuses[0].status === 'expired')
      ) {
        return true;
      } else {
        return false;
      }
    },
    isGroupSelected(group) {
      // Проверяем, выбраны ли все пользователи в группе
      return group.every(user =>
        this.students_id.includes(Number(user.user_id))
      );
    },
    selectGroup(group) {
      // Обработчик для выбора всех пользователей в группе
      if (this.isGroupSelected(group)) {
        const members_id = this.students_id.filter(
          userId => !group.some(user => Number(user.user_id) === Number(userId))
        );
        const members = this.students.filter(
          userId =>
            !group.some(user => Number(user.user_id) === Number(userId.user_id))
        );
        this.SET_USERS_ID(members_id);
        this.SET_USERS(members);
      } else {
        const members_id = this.students_id.concat(
          group
            .filter(user => !this.students_id.includes(Number(user.user_id)))
            .map(user => Number(user.user_id))
        );

        const members = this.students.concat(
          group
            .filter(
              user =>
                !this.students.some(member => member.user_id === user.user_id)
            )
            .map(user => ({ ...user })) // Копируем объекты для создания новых ссылок
        );

        this.SET_USERS_ID(members_id);
        this.SET_USERS(members);
      }
    },
    selectUser(userId) {
      // Обработчик для выбора отдельного пользователя
      if (this.isSelected(userId) && !this.isUserPermit(userId)) {
        this.FILTER_AND_REMOVE_USERS(Number(userId.user_id));
        this.FILTER_AND_REMOVE_USERS_ID(Number(userId.user_id));
      } else if (!this.isSelected(userId)) {
        this.PYSH_USERS_ID(userId.user_id);
        this.PYSH_USERS(userId);
      }
    }
  }
};
